import React, { useContext, useState } from 'react';
import { ContextProps } from '../types/ContextProps';
import { Violation } from 'src/types/ViewModel/Stowage/Violation/Violation';

type ViolationsContext = {
    violations: Violation[];
    setViolations: (violations: Violation[] | null) => void;
    savedViolations: Violation[];
    setSavedViolations: (violations: Violation[] | null) => void;
    isStowagePlanValid: boolean;
    setIsStowagePlanValid: (isStowagePlanValid: boolean) => void;
};

export const ViolationsContext = React.createContext<ViolationsContext>(undefined!);

export const ViolationsProvider = ({ children }: ContextProps) => {
    const [violations, setViolations] = useState<Violation[]>(null);
    const [savedViolations, setSavedViolations] = useState<Violation[]>(null);
    const [isStowagePlanValid, setIsStowagePlanValid] = useState<boolean>(true);

    return (
        <ViolationsContext.Provider
            value={{
                violations,
                setViolations,
                isStowagePlanValid,
                setIsStowagePlanValid,
                savedViolations,
                setSavedViolations,
            }}
        >
            {children}
        </ViolationsContext.Provider>
    );
};

export const useViolationsStore = () => useContext(ViolationsContext);
